import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './admin-catalog-page.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Button, Tabs } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { CatalogsListDataRequest } from '@entities/catalog/api/catalog-types';
import { useCatalogsListSharedQuery } from '@entities/catalog/libs/hooks/use-catalogs-list-shared-query/use-catalogs-list-shared-query';
import { FilterCatalogs } from '@features/catalog/filter-catalogs/ui/filter-catalogs';
import { DEFAULT_CATALOGS_LIST_PARAMETERS } from '@entities/catalog/config/store-constants';
import { ListCatalogs } from '@widgets/list-catalogs/ui/list-catalogs';
import { ListAdminProducts } from '@widgets/list-admin-products/ui/list-admin-products';
import { DEFAULT_ADMIN_PRODUCTS_LIST_PARAMETERS } from '@entities/product/config/store-constants';
import { useAdminProductsListSharedQuery } from '@entities/product/libs/hooks/use-admin-products-list-shared-query/use-admin-products-list-shared-query';
import { FilterAdminProducts } from '@features/product/filter-admin-products/ui/filter-admin-products';
import { ProductsListDataRequest } from '@entities/product/api/product-types';
import { CreateCatalog } from '@features/catalog/mutate-catalog/ui/create-catalog';
import { CreateProduct } from '@features/product/mutate-product/ui/create-product';
import { useUrlTabs } from '@shared/lib/hooks/use-url-tabs/use-url-tabs';
import { AdminCatalogPageTabs } from '../config/constants';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';
import { useSyncCRM } from '@features/product/crm-sync/lib/hooks/use-sync-crm/use-sync-crm';

export const AdminCatalogPage = () => {
    const history = useHistory();

    const { tabValue, handleSetTabValue } = useUrlTabs({
        searchUrlKey: 'tab',
        tabValues: Object.values(AdminCatalogPageTabs),
        initialTabValue: AdminCatalogPageTabs.Catalogs,
    });

    const [catalogsListParameters, setCatalogsListParameters] = useSearchParams<CatalogsListDataRequest>(
        DEFAULT_CATALOGS_LIST_PARAMETERS
    );
    const [productsListParameters, setProductsListParameters] = useSearchParams<ProductsListDataRequest>(
        DEFAULT_ADMIN_PRODUCTS_LIST_PARAMETERS
    );

    const [getCatalogsList] = useCatalogsListSharedQuery(catalogsListParameters);
    const [getProductsList] = useAdminProductsListSharedQuery(productsListParameters);

    const { handleSyncCRM } = useSyncCRM();

    useEffect(() => {
        getCatalogsList(catalogsListParameters);
    }, [catalogsListParameters]);

    useEffect(() => {
        getProductsList(productsListParameters);
    }, [productsListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Title size='h6'>Все продукты и каталоги</Title>
                    {tabValue === AdminCatalogPageTabs.Catalogs && (
                        <FilterCatalogs
                            catalogsListParameters={catalogsListParameters}
                            setCatalogsListParameters={setCatalogsListParameters}>
                            <CreateCatalog />
                        </FilterCatalogs>
                    )}
                    {tabValue === AdminCatalogPageTabs.Products && (
                        <FilterAdminProducts
                            productsListParameters={productsListParameters}
                            setProductsListParameters={setProductsListParameters}>
                            <CreateProduct
                                type='list'
                                menuList={[
                                    {
                                        label: 'Синхронизировать продуткы',
                                        handler: handleSyncCRM,
                                    },
                                ]}
                            />
                        </FilterAdminProducts>
                    )}
                </Head>
            </HeadWrapper>
            <Tabs
                size='sm'
                list={[
                    {
                        label: <Typography size='body1_long'>Все каталоги</Typography>,
                        tab: (
                            <ListCatalogs
                                catalogsListParameters={catalogsListParameters}
                                setCatalogsListParameters={setCatalogsListParameters}
                            />
                        ),
                        active: tabValue === AdminCatalogPageTabs.Catalogs,
                        handler: () => handleSetTabValue(AdminCatalogPageTabs.Catalogs),
                    },
                    {
                        label: <Typography size='body1_long'>Все продукты</Typography>,
                        tab: (
                            <ListAdminProducts
                                productsListParameters={productsListParameters}
                                setProductsListParameters={setProductsListParameters}
                            />
                        ),
                        active: tabValue === AdminCatalogPageTabs.Products,
                        handler: () => handleSetTabValue(AdminCatalogPageTabs.Products),
                    },
                ]}
            />
        </Wrapper>
    );
};
